export default __webpack_public_path__ + "static/media/Group9252.3d86f8aa.svg";